import React, { MouseEvent, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './Modal.module.scss';
import cx from 'classnames';
import { Icon, Text } from 'components';

type Props = {
  title: string;
  onClose(): void;
  children: React.ReactNode;
  type?: string;
  contentContainerElementId?: string;
  closeOnBackdrop?: boolean;
  isRelative?: boolean;
  hideHeader?: boolean;
  darkerBackground?: boolean;
};

export const Modal = ({
  title,
  onClose,
  children,
  type,
  contentContainerElementId,
  closeOnBackdrop,
  isRelative = false,
  hideHeader = false,
  darkerBackground = false,
}: Props) => {
  const container = document.getElementById('modal');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (!container) return null;

  const onBackdropClick = () => {
    closeOnBackdrop && onClose();
  };

  const onContentClick = (e: MouseEvent) => {
    e.stopPropagation();
  };

  const renderModal = () => {
    return (
      <div
        className={cx(styles.backdrop, type && styles[type], {
          [styles.relative]: isRelative,
          [styles.hideHeader]: hideHeader,
          [styles.darkerBackground]: darkerBackground,
        })}
        onClick={onBackdropClick}>
        <div className={styles.container} onClick={onContentClick}>
          <div className={styles.header}>
            <Text type="h5">{title}</Text>
            <Icon name="Close" onClick={onClose} />
          </div>
          {/*to set a styles from prop a higher priority*/}
          <div id={contentContainerElementId} className={styles.contentContainer}>
            {children}
          </div>
        </div>
      </div>
    );
  };

  return <>{isRelative ? renderModal() : createPortal(renderModal(), container)}</>;
};
